export default "__VITE_ASSET__DKI68StB__"